/**
 * Maps a slug like "maruti" → human label "Maruti Suzuki" or "swift" → "Swift".
 * Stays tolerant: unknown slugs fall back to title-cased slug words.
 */
import cities from "../data/seo/cities.json";
import services from "../data/seo/services.json";
import brands from "../data/seo/brands.json";
import localities from "../data/seo/localities.json";
import intros from "../data/seo/intros.json";

const titleCase = (slug) =>
  String(slug || "")
    .split("-")
    .filter(Boolean)
    .map((s) => s.charAt(0).toUpperCase() + s.slice(1))
    .join(" ");

export const findCity = (slug) =>
  cities.find((c) => c.slug === slug) || null;

export const findService = (slug) =>
  services.find((s) => s.slug === slug) || null;

export const findBrand = (slug) =>
  brands.find((b) => b.slug === slug) || null;

export const findLocality = (slug) => {
  const l = localities[slug];
  return l ? { slug, ...l } : null;
};

export const findModel = (brandSlug, modelSlug) => {
  const brand = findBrand(brandSlug);
  if (!brand) return null;
  const inList = brand.models.includes(modelSlug);
  return inList ? { slug: modelSlug, name: titleCase(modelSlug), brand } : null;
};

export const labelOf = (slug) => titleCase(slug);

/** AI-generated unique intro for a given canonical path, if available. */
export const findIntro = (canonicalPath) => intros[canonicalPath] || null;

export { cities, services, brands, localities };
